import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["alt", "src"]

import { createStyle } from '@v1/composables/create-style';
import { StyleExtender } from '@v1/composables/style-extender';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseImage',
  props: {
  alt: {
    type: String,
    required: false,
    default: '',
  },
  aspectRatio: {
    type: [Number, String],
    required: false,
    default: 'auto',
  },
  objectFit: {
    type: String,
    required: false,
    default: 'cover',
  },
  src: {
    type: [Object, String],
    required: false,
    default: '//:0',
  },
  styleExtension: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  asReactive: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const styleExtender = new StyleExtender(
  { variablePrefix: '--v1-base-image', extraPropertyNames: ['filter'] },
);

const props = __props;

// data
const style = createStyle({
  image: {
    aspectRatio: props.aspectRatio,
    objectFit: props.objectFit,
  },
}, {
  asReactive: props.asReactive,
});

styleExtender.extend({
  target: style.image,
  extension: props.styleExtension.image,
  selector: 'image',
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", _mergeProps(_ctx.$attrs, {
    alt: __props.alt,
    src: __props.src,
    class: _ctx.$style.image,
    style: _unref(style).image
  }), null, 16, _hoisted_1))
}
}

})